<style>



</style>

<template>

<v-container>

    <v-layout row wrap justify-center>

        <v-flex xs12 sm10 md8 lg6>

            <h1 class="text-xs-center display-1">{{content.title}}</h1>
            <h2 class="text-xs-center">{{content.hey}} {{user.first_name}}!</h2>

            <v-layout column wrap>

              <!-- EDIT EMAIL -->
              <v-flex xs12 class="mt-3">
                <v-card class="pa-2">
                  <v-layout v-if="loadings.email" row wrap justify-center>
                    <v-progress-circular indeterminate color="primary" :size="40" class="ma-3"></v-progress-circular>
                  </v-layout>
                  <v-layout v-else row wrap>
                    <v-flex shrink>
                      <v-card-title class="text-no-wrap">{{content.email}}:</v-card-title>
                    </v-flex>
                    <v-flex grow>
                      <v-layout v-if="!edit.email" row wrap>
                        <v-flex grow>
                          <v-card-text v-if="!edit.email">
                            <strong>
                              {{user.email}}
                            </strong>
                            <strong v-if="notChanged.email" class="warning--text mx-2">
                              {{content.notChanged.email}}
                            </strong>
                            <strong v-if="changed.email" class="success--text mx-2">
                              {{content.changed.email}}
                            </strong>
                          </v-card-text>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn flat icon color="light-blue" @click="edit.email = true">
                            <v-icon>edit</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-form v-else @submit.prevent="editEmail" ref="emailForm">
                        <v-layout row wrap>
                          <v-flex xs12 sm8>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-text-field type="email" v-model="form.email" :label="content.email" :rules="rules.email" validate-on-blur></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field type="email" v-model="form.email_confirmation" :label="content.confirm +' '+ content.email" :rules="rules.email_confirm" validate-on-blur></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-layout row wrap grow justify-space-around align-center style="height:100%;">
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn color="success" type="submit">{{content.save}}</v-btn>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn dark color="grey" @click="edit.email = false">{{content.cancel}}</v-btn>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <!-- EDIT PASSWORD -->
              <v-flex xs12 class="mt-3">
                <v-card class="py-2 px-4">
                  <v-layout v-if="loadings.password" row wrap justify-center>
                    <v-progress-circular indeterminate color="primary" :size="40" class="ma-3"></v-progress-circular>
                  </v-layout>
                  <v-layout v-else row wrap>
                    <v-flex shrink>
                      <v-card-title class="text-no-wrap">{{content.password}}:</v-card-title>
                    </v-flex>
                    <v-flex grow>
                      <v-form v-if="edit.password" @submit.prevent="editPassword" ref="passwordForm">
                        <v-flex v-if="passwords.error" class="px-4 my-2">
                          <v-alert :value="true" color="error" icon="warning" outline>{{passwords.error}}</v-alert>
                        </v-flex>
                        <input type="email" name="email" class="d-none" autocomplete="email" />
                        <v-layout row wrap>
                          <v-flex xs12 sm8>
                            <v-layout row wrap style="max-width: 500px">
                              <v-flex xs12>
                                <v-layout row nowrap>
                                  <v-flex grow>
                                    <v-text-field autocomplete="current-password" :type="passwords.reveal.current ? 'text' : 'password'" v-model="form.current_password" :label="content.current_password" :rules="rules.current_password" validate-on-blur></v-text-field>
                                  </v-flex>
                                  <v-flex v-if="form.current_password" shrink>
                                    <v-btn flat icon color="primary" @click="passwords.reveal.current = !passwords.reveal.current">
                                      <v-icon>{{passwords.reveal.current ? 'visibility_off' : 'visibility'}}</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12>
                                <v-layout row nowrap>
                                  <v-flex grow>
                                    <v-text-field autocomplete="new-password" :type="passwords.reveal.new ? 'text' : 'password'" v-model="form.password" :label="content.new_password" :rules="rules.new_password" validate-on-blur></v-text-field>
                                  </v-flex>
                                  <v-flex v-if="form.password" shrink>
                                    <v-btn flat icon color="primary" @click="passwords.reveal.new = !passwords.reveal.new">
                                      <v-icon>{{passwords.reveal.new ? 'visibility_off' : 'visibility'}}</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12>
                                <v-layout row nowrap>
                                  <v-flex grow>
                                    <v-text-field autocomplete="new-password" :type="passwords.reveal.confirm ? 'text' : 'password'" v-model="form.password_confirmation" :label="content.confirm+' '+content.password" :rules="rules.confirm_password" validate-on-blur></v-text-field>
                                  </v-flex>
                                  <v-flex v-if="form.password_confirmation" shrink>
                                    <v-btn flat icon color="primary" @click="passwords.reveal.confirm = !passwords.reveal.confirm">
                                      <v-icon>{{passwords.reveal.confirm ? 'visibility_off' : 'visibility'}}</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12>
                                <passwordStr :password="form.password" v-on:pwdStr="updatePwdStr" class="mx-4" />
                              </v-flex>

                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-layout row wrap grow justify-space-around align-center style="height:100%;">
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn color="success" type="submit">{{content.save}}</v-btn>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn dark color="grey" @click="edit.password = false">{{content.cancel}}</v-btn>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-form>
                      <v-flex v-else>
                        <v-layout row wrap align-center>
                          <v-flex grow align-center>
                            <strong class="h3">●●●●●●●●●●●●</strong>
                            <strong v-if="changed.password" class="success--text mx-2">
                              {{content.changed.password}}
                            </strong>
                          </v-flex>
                          <v-flex shrink>
                            <v-btn flat icon color="light-blue" @click="edit.password = true">
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <!-- EDIT NAME -->
              <v-flex xs12 class="mt-3">
                <v-card class="pa-2">
                  <v-layout v-if="loadings.name" row wrap justify-center>
                    <v-progress-circular indeterminate color="primary" :size="40" class="ma-3"></v-progress-circular>
                  </v-layout>
                  <v-layout v-else row wrap>
                    <v-flex shrink>
                      <v-card-title class="text-no-wrap">{{content.name}}:</v-card-title>
                    </v-flex>
                    <v-flex grow>
                      <v-layout v-if="!edit.name" row wrap>
                        <v-flex grow>
                          <v-card-text v-if="!edit.name">
                            <strong>
                              {{user.first_name}} {{user.last_name}}
                            </strong>
                            <strong v-if="notChanged.name" class="warning--text mx-2">
                              {{content.notChanged.name}}
                            </strong>
                            <strong v-if="changed.name" class="success--text mx-2">
                              {{content.changed.name}}
                            </strong>
                          </v-card-text>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn flat icon color="light-blue" @click="edit.name = true">
                            <v-icon>edit</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-form v-else @submit.prevent="editName" ref="nameForm">
                        <v-layout row wrap>
                          <v-flex xs12 sm8>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-text-field type="text" v-model="form.fname" :label="content.fname" :rules="rules.fname" validate-on-blur></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                <v-text-field type="text" v-model="form.lname" :label="content.lname" :rules="rules.lname" validate-on-blur></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-layout row wrap grow justify-space-around align-center style="height:100%;">
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn color="success" type="submit">{{content.save}}</v-btn>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 sm12>
                                <v-layout row wrap justify-center>
                                  <v-btn dark color="grey" @click="edit.name = false">{{content.cancel}}</v-btn>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

            </v-layout>

        </v-flex>

    </v-layout>

</v-container>

</template>

<script>
import passwordStr from '../tools/passwordStr';
export default {
    components: { passwordStr },
    data() {
            return {
                locale: null,
                user: {
                    first_name: null,
                    last_name: null,
                    email: null,
                },
                edit: {
                    email: false,
                    password: false,
                    name: false,
                },
                form: {
                    email_valid: false,
                    email: null,
                    email_confirmation: null,
                    fname: null,
                    lname: null,
                    current_password: null,
                    password: null,
                    password_confirmation: null,
                },
                loadings: {
                  email: false,
                  password: false,
                  name: false,
                },
                changed: {
                  email: false,
                  password: false,
                  name: false,
                },
                notChanged: {
                  email: false,
                  password: false,
                  name: false,
                },
                passwords: {
                  reveal: {
                    current: false,
                    new: false,
                    confirm: false,
                  },
                  strength: 0,
                  error: null,
                },
            };
        },
        created() {
          this.locale = Lang.get();
          this.setLang();
          this.setRules();
        },
        mounted() {
          let auth = Auth.d();
          this.user.email = auth.email;
          this.user.first_name = auth.fname;
          this.user.last_name = auth.lname;
          this.form.email = auth.email;
          this.form.fname = auth.fname;
          this.form.lname = auth.lname;
          this.getUser();
        },
        methods: {
            getUser() {
                axios.get(
                    'api/user'
                ).then(res => {
                    this.user = res.data;
                    this.form.email = this.user.email;
                    this.form.fname = this.user.first_name;
                    this.form.lname = this.user.last_name;
                }).catch(err => {
                  console.log(err);
                });
            },
            editEmail() {
              if (this.$refs.emailForm.validate()) {
                if (this.form.email !== this.user.email) {
                  this.loadings.email = true;
                  axios.post(
                    'api/user/edit/email',
                    {
                      email: this.form.email,
                      email_confirmation: this.form.email_confirmation
                    }
                  ).then(res => {
                    this.user.email = res.data.success;
                    this.changed.email = true;
                    this.edit.email = false;
                    this.loadings.email = false;
                    this.form.email_confirmation = null;
                    setTimeout(function(){
                      this.changed.email = false;
                    }.bind(this) ,5000);
                  }).catch(err => {
                    this.form.email_confirmation = null;
                    this.edit.email = false;
                    this.notChanged.email = true;
                    setTimeout(function(){
                      this.notChanged.email = false;
                    }.bind(this) ,5000);
                    this.loadings.email = false;
                  });
                } else {
                  this.form.email = this.user.email;
                  this.form.email_confirmation = null;
                  this.edit.email = false;
                  this.notChanged.email = true;
                  setTimeout(function(){
                    this.notChanged.email = false;
                  }.bind(this) ,5000);
                }
              }
            },
            editPassword(){
              if (this.$refs.passwordForm.validate()){
                this.loadings.password = true;
                axios.post(
                  'api/user/edit/password',
                  {
                    current_password: this.form.current_password,
                    password: this.form.password,
                    password_confirmation: this.form.password_confirmation
                  }
                ).then(res => {
                  this.changed.password = true;
                  this.edit.password = false;
                  this.loadings.password = false;
                  this.passwords.error = null;
                  this.form.password = null;
                  this.form.password_confirmation = null;
                  this.passwords.reveal.current = false;
                  this.passwords.reveal.new = false;
                  this.passwords.reveal.confirm = false;
                  setTimeout(function(){
                    this.changed.password = false;
                  }.bind(this) ,5000);
                }).catch(err => {
                  if (err.response.data.type == 3) {
                    this.passwords.error = this.content.errors.wrong_password;
                  } else if (err.response.data.type == 2) {
                    this.passwords.error = this.content.errors.same_password;
                  }
                  this.loadings.password = false;
                });
              }
            },
            editName() {
              if (this.$refs.nameForm.validate()) {
                if (this.form.fname !== this.user.first_name || this.form.lname !== this.user.last_name) {
                  this.loadings.name = true;
                  axios.post(
                    'api/user/edit/name',
                    {
                      fname: this.form.fname,
                      lname: this.form.lname
                    }
                  ).then(res => {
                    this.user.first_name = res.data.success.fname;
                    this.user.last_name = res.data.success.lname;
                    this.changed.name = true;
                    this.edit.name = false;
                    this.loadings.name = false;
                    setTimeout(function(){
                      this.changed.name = false;
                    }.bind(this) ,5000);
                  }).catch(err => {
                    this.notChanged.name = true;
                    setTimeout(function(){
                      this.notChanged.name = false;
                    }.bind(this) ,5000);
                    this.loadings.name = false;
                  });
                } else {
                  this.notChanged.name = true;
                  this.edit.name = false;
                  setTimeout(function(){
                    this.notChanged.name = false;
                  }.bind(this) ,5000);
                }
              }
            },
            updatePwdStr(str) {
              this.passwords.strength = str;
            },
            setRules() {
              this.rules = {
                  email: [
                      v => !!v || this.content.rules.email[0],
                      v => /.+@.+/.test(v) || this.content.rules.email[1],
                  ],
                  email_confirm: [
                    v => !!v || this.content.rules.email_confirm[0],
                    v => v == this.form.email || this.content.rules.email_confirm[1],
                  ],
                  fname: [
                      v => !!v || this.content.rules.fname[0],
                      v => v && v.length > 1 || this.content.rules.fname[1],
                      v => v && v.length < 21 || this.content.rules.fname[2],
                  ],
                  lname: [
                      v => !!v || this.content.rules.lname[0],
                      v => v && v.length > 1 || this.content.rules.lname[1],
                      v => v && v.length < 21 || this.content.rules.lname[2],
                  ],
                  current_password : [
                    v => !!v || this.content.rules.passwords.current[0],
                  ],
                  new_password: [
                    v => !!v || this.content.rules.passwords.new[0],
                    v => v != this.form.current_password || this.content.rules.passwords.new[3],
                    v => this.passwords.strength > 25 || this.content.rules.passwords.new[1],
                    v => v && v.length < 19 || this.content.rules.passwords.new[2],
                  ],
                  confirm_password: [
                    v => !!v || this.content.rules.passwords.confirm[0],
                    v => v == this.form.password || this.content.rules.passwords.confirm[1],
                  ],
              }
            },
            setLang() {
                if (this.locale == "en") {
                    this.content = {
                        title: "Profile",
                        hey: 'Hey',
                        email: 'Email Address',
                        name: 'Full Name',
                        fname: 'First Name',
                        lname: 'Last Name',
                        password: 'Password',
                        edit_password: 'Edit Password',
                        new_password: 'New Password',
                        current_password: 'Current Password',

                        rules: {
                          email: [
                            'Email is required',
                            'Email must be valid',
                          ],
                          email_confirm: [
                            'Email confirmation is required',
                            'The Email addresses doe\'s not match',
                          ],
                          fname: [
                            'First Name is required',
                            'First Name must be more than 1 characters',
                            'First Name can\'t be more than 20 characters',
                          ],
                          lname: [
                            'Last Name is required',
                            'Last Name must be more than 1 characters',
                            'Last Name can\'t be more than 20 characters',
                          ],
                          passwords: {
                            current: [
                              'Current Password is required',
                            ],
                            new: [
                              'New Password is required',
                              'The new Password is too weak',
                              'The new Password is too long',
                              'You can\'t use the same Password',
                            ],
                            confirm: [
                              'Password Confirmation is required',
                              'The Passwords does not match',
                            ],
                          },
                        },

                        changed: {
                          email: 'the Email address was changed',
                          password: 'the Password was changed',
                          name: 'the Name was changed',
                        },
                        notChanged: {
                          email: 'the Email address was not changed',
                          password: 'the Password was not changed',
                          name: 'the Name was not changed',
                        },
                        errors: {
                          'wrong_password': 'The Current Password is Wrong!',
                          'same_password': 'You used the same Password',
                        },

                        edit: 'Edit',
                        save: 'Save',
                        cancel: 'Cancel',
                        confirm: 'Confirm',
                    };
                } else if (this.locale == "he") {
                    this.content = {
                        title: "פרופיל",
                        hey: 'היי',
                        email: 'כתובת אימייל',
                        name: 'שם מלא',
                        fname: 'שם פרטי',
                        lname: 'שם משפחה',
                        password: 'סיסמא',
                        edit_password: 'שינוי סיסמא',
                        new_password: 'סיסמא חדשה',
                        current_password: 'סיסמא נוכחית',

                        rules: {
                          email: [
                            'נדרש למלא כתובת אימייל',
                            'כתובת האימייל אינה תקינה',
                          ],
                          email_confirm: [
                            'נדרש למלא אישור כתובת אימייל',
                            'כתובות האימייל אינן תואמות',
                          ],
                          fname: [
                            'נדרש למלא שם פרטי',
                            'שם פרטי חייב להיות ארוך מתו 1',
                            'שם פרטי לא יכול להיות ארוך מ-20 תווים',
                          ],
                          lname: [
                            'נדרש למלא שם משפחה',
                            'שם משפחה חייב להיות ארוך מתו 1',
                            'שם משפחה לא יכול להיות ארוך מ-20 תווים',
                          ],
                          passwords: {
                            current: [
                              'נדרש למלא את הסיסמא הנוכחית',
                            ],
                            new: [
                              'נדרש למלא סיסמא חדשה',
                              'הסיסמא החדשה חלשה מידי',
                              'הסיסמא החדשה ארוכה מידי',
                              'אי אפשר להשתמש באותה הסיסמא',
                            ],
                            confirm: [
                              'נדרש למלא אישור סיסמא',
                              'הסיסמאות אינן תואמות',
                            ],
                          },
                        },

                        changed: {
                          email: 'כתובת האימייל השתנתה',
                          password: 'הסיסמא השתנתה',
                          name: 'השם השתנה',
                        },
                        notChanged: {
                          email: 'כתובת האימייל לא השתנתה',
                          password: 'הסיסמא לא השתנתה',
                          name: 'השם לא השתנה',
                        },
                        errors: {
                          'wrong_password': 'הסיסמא הנוכחית שגויה!',
                          'same_password': 'השתמשת באותה הסיסמא',
                        },

                        edit: 'עריכה',
                        save: 'שמירה',
                        cancel: 'ביטול',
                        confirm: 'אישור',
                    };
                }
            }
        }
};

</script>
